import './_data-list.scss';

/* Init DataList component and create function to format number values */

export default function DataList() {
    const $dataComponents = document.querySelectorAll('.data-list');

    if ($dataComponents) {
        $dataComponents.forEach(($dataComponent: any) => {
            const $tags = $dataComponent.querySelectorAll('.dynamic-tag[dynamic-tag="monitoring-data__static"]');
            const $units = $dataComponent.querySelector('.units');
            const $unitsLabel = $dataComponent.querySelector('.units-label');
            const unitArray = $units.innerText.split(', ');
            const unitLabelArray = $unitsLabel.innerText.split(', ');

            $tags.forEach(($tag: any) => {
                const $tagLabel = $tag.querySelector('.tag-label') as HTMLSpanElement;
                if ($tagLabel.innerHTML && !isNaN(Number($tagLabel.innerHTML))) {
                    const value = Number($tagLabel.innerHTML);
                    const sign = $tagLabel.innerHTML ? $tagLabel.innerHTML[0] : '';
                    const signVisible = sign === '+' || sign === '-';
                    $tagLabel.innerHTML = signVisible ? sign + nFormatter(value) : nFormatter(value);
                }else{
                    if($tagLabel.querySelector('a')){
                        $tagLabel.innerHTML = $tagLabel.querySelector('a')?.innerText ?? '';
                    }
                }
            });



            function nFormatter(num: number) {
                let splitText = unitArray;
                let splitLabel = unitLabelArray;

                if (num >= 1000000000) {
                    return (
                        removeExcess((num / 1000000000).toFixed(1))
                            .toString()
                            .replace(',', '.')
                            .replace(/\.0$/, '') +
                        '<span class="unit" aria-hidden="true">' +
                        ' ' +
                        splitText[0] +
                        '</span>'
                        +
                        '<span class="sr-only">' +
                        ' ' +
                        splitLabel[0] +
                        '</span>'
                    );
                }
                if (num >= 1000000) {
                    return (
                        removeExcess((num / 1000000).toFixed(1))
                            .toString()
                            .replace(',', '.')
                            .replace(/\.0$/, '') +
                        '<span class="unit" aria-hidden="true">' +
                        ' ' +
                        splitText[1] +
                        '</span>'
                        +
                        '<span class="sr-only">' +
                        ' ' +
                        splitLabel[1] +
                        '</span>'
                    );
                }
                if (num >= 1000) {
                    return (
                        removeExcess((num / 1000).toFixed(1))
                            .toString()
                            .replace(',', '.')
                            .replace(/\.0$/, '') +
                        '<span class="unit" aria-hidden="true">' +
                        ' ' +
                        splitText[2] +
                        '</span>'
                        +
                        '<span class="sr-only">' +
                        ' ' +
                        splitLabel[2] +
                        '</span>'
                    );
                }
                if (num < 1) {
                    return num.toFixed(1).toString().replace(',', '.');
                }
                return removeExcess(num.toString()).toString().replace(',', '.');
            }

            function removeExcess(num: string) {
                const valueString = num.toString();
                const p = valueString.indexOf('.');

                if (p === -1) {
                    return num;
                } else {
                    const fractionalPart = valueString.slice(p + 1).replace(/0+$/, '');

                    if (fractionalPart === '') {
                        return parseInt(valueString.slice(0, p));
                    } else {
                        return parseFloat(valueString.slice(0, p + 1) + fractionalPart);
                    }
                }
            }
        });
    }
}
